export default function byX(result) {
  const { data, meta } = result;
  return data.reduce((bx, r) => {
    const { x } = r;
    bx[x] = { data: [r], meta }; // eslint-disable-line no-param-reassign
    return bx;
  }, {});
}
